// Customer-facing confirmation after "Update STB". The fallback contact is the company's own
// phone (Settings > Company Details); with none set it just says to contact us.
export const retrackMessage = (phone) =>
  `Update Sent. If your STB doesn't get updated in 15-20 mins, ${phone ? `WhatsApp us at ${phone}` : 'please contact us'}.`;
